import { combineEpics } from "redux-observable";
import { createAccountEpic, fetchAccountsEpic } from "./modules/accounts/epics";
import {
  createCardEpic,
  createDepositEpic,
  createRecurringDepositEpic,
  fetchBankAccountsEpic,
  fetchCardsEpic,
  linkBankAccountEpic,
} from "./modules/billing/epics";
import { createUserEpic, fetchSelfEpic, loginEpic } from "./modules/user/epics";

const rootEpic = combineEpics(
  createUserEpic,
  fetchSelfEpic,
  loginEpic,
  fetchBankAccountsEpic,
  linkBankAccountEpic,
  fetchAccountsEpic,
  createAccountEpic,
  createCardEpic,
  createDepositEpic,
  createRecurringDepositEpic,
  fetchCardsEpic
);

export default rootEpic;
